<template>
<div class="chapter">
<div class="inner_page">
<h2 class="pn"><a id="p1"></a>PART I</h2>
<h2 class="pt"><a href="#/Contents.htm#ch0f">Europe</a><a id="p2"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PART_I_EUROPE.vue?096e6f04